import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Send, MessageSquare, X, Minus } from 'lucide-react';
export function Contact() {
  const [isOpen, setIsOpen] = useState(true);
  const [message, setMessage] = useState('');
  const [messages, setMessages] = useState([{
    id: 1,
    text: 'Hi there! 👋 How can we help you today?',
    sender: 'agent'
  }]);
  const handleSend = (e: React.FormEvent) => {
    e.preventDefault();
    if (!message.trim()) return;
    setMessages([...messages, {
      id: Date.now(),
      text: message,
      sender: 'user'
    }]);
    setMessage('');
    // Mock reply
    setTimeout(() => {
      setMessages(prev => [...prev, {
        id: Date.now(),
        text: 'Thanks for reaching out! A member of our team will be with you shortly.',
        sender: 'agent'
      }]);
    }, 1000);
  };
  return <div className="min-h-[80vh] bg-[#FAF8F4] pt-32 pb-24 px-6 flex flex-col items-center" data-id="element-3546">
      <div className="text-center mb-12" data-id="element-3547">
        <h1 className="text-4xl md:text-5xl font-bold text-[#2B211A] mb-4 font-title tracking-tight" data-id="element-3548">
          Contact Us
        </h1>
        <p className="text-neutral-500 text-lg max-w-md mx-auto" data-id="element-3549">
          Have questions about Giga? We're here to help. Start a chat with our
          team below.
        </p>
      </div>

      {/* Mock Crisp-style Chat Widget */}
      <div className="w-full max-w-[380px] relative" data-id="element-3550">
        <AnimatePresence mode="wait" data-id="element-3551">
          {isOpen ? <motion.div key="chat-window" initial={{
          opacity: 0,
          y: 20,
          scale: 0.95
        }} animate={{
          opacity: 1,
          y: 0,
          scale: 1
        }} exit={{
          opacity: 0,
          y: 20,
          scale: 0.95
        }} transition={{
          duration: 0.2
        }} className="bg-white rounded-2xl shadow-[0_12px_40px_-12px_rgba(0,0,0,0.15)] border border-[#EAE4D9] overflow-hidden flex flex-col h-[500px]" data-id="element-3552">
              {/* Chat Header */}
              <div className="bg-[#EA580C] p-4 flex items-center justify-between text-white" data-id="element-3553">
                <div className="flex items-center gap-3" data-id="element-3554">
                  <div className="relative" data-id="element-3555">
                    <div className="w-10 h-10 rounded-full bg-white/20 flex items-center justify-center" data-id="element-3556">
                      <img src="https://cdn.magicpatterns.com/uploads/bxQBDjkPJfWx4r7DHyApcd/Vector.png" alt="Giga" className="w-5 h-5 object-contain brightness-0 invert" data-id="element-3557" />
                    </div>
                    <div className="absolute bottom-0 right-0 w-3 h-3 bg-green-400 border-2 border-[#EA580C] rounded-full" data-id="element-3558" />
                  </div>
                  <div data-id="element-3559">
                    <h3 className="font-bold text-sm" data-id="element-3560">Giga Support</h3>
                    <p className="text-xs text-white/80" data-id="element-3561">
                      Typically replies in a few minutes
                    </p>
                  </div>
                </div>
                <button onClick={() => setIsOpen(false)} className="w-8 h-8 rounded-full hover:bg-white/20 flex items-center justify-center transition-colors" data-id="element-3562">
                  <Minus size={18} data-id="element-3563" />
                </button>
              </div>

              {/* Chat Messages */}
              <div className="flex-1 p-4 overflow-y-auto bg-[#FAF8F4] flex flex-col gap-4" data-id="element-3564">
                {messages.map(msg => <div key={msg.id} className={`flex ${msg.sender === 'user' ? 'justify-end' : 'justify-start'}`} data-id="element-3565">
                    <div className={`max-w-[85%] rounded-2xl px-4 py-2.5 text-[15px] ${msg.sender === 'user' ? 'bg-[#EA580C] text-white rounded-br-sm' : 'bg-white border border-[#EAE4D9] text-[#2B211A] rounded-bl-sm shadow-sm'}`} data-id="element-3566">
                      {msg.text}
                    </div>
                  </div>)}
              </div>

              {/* Chat Input */}
              <div className="p-4 bg-white border-t border-[#EAE4D9]" data-id="element-3567">
                <form onSubmit={handleSend} className="relative flex items-center" data-id="element-3568">
                  <input type="text" value={message} onChange={e => setMessage(e.target.value)} placeholder="Compose your message..." className="w-full bg-[#FAF8F4] border border-[#EAE4D9] rounded-full pl-4 pr-12 py-3 text-[15px] text-[#2B211A] focus:outline-none focus:border-[#EA580C] focus:ring-1 focus:ring-[#EA580C] transition-all" data-id="element-3569" />
                  <button type="submit" disabled={!message.trim()} className="absolute right-2 w-8 h-8 rounded-full bg-[#EA580C] text-white flex items-center justify-center disabled:opacity-50 disabled:bg-neutral-300 transition-colors" data-id="element-3570">
                    <Send size={14} className="ml-0.5" data-id="element-3571" />
                  </button>
                </form>
                <div className="text-center mt-3" data-id="element-3572">
                  <a href="https://crisp.chat" target="_blank" rel="noopener noreferrer" className="text-[10px] font-medium text-neutral-400 hover:text-neutral-600 transition-colors flex items-center justify-center gap-1" data-id="element-3573">
                    Powered by Crisp
                  </a>
                </div>
              </div>
            </motion.div> : <motion.div key="chat-button" initial={{
          opacity: 0,
          scale: 0.9
        }} animate={{
          opacity: 1,
          scale: 1
        }} exit={{
          opacity: 0,
          scale: 0.9
        }} className="flex justify-center" data-id="element-3574">
              <button onClick={() => setIsOpen(true)} className="flex items-center gap-3 bg-[#EA580C] hover:bg-[#D04D0A] text-white px-8 py-4 rounded-full font-bold text-lg transition-all shadow-lg shadow-orange-900/20 hover:shadow-xl hover:-translate-y-0.5" data-id="element-3575">
                <MessageSquare size={20} data-id="element-3576" />
                Chat with us
              </button>
            </motion.div>}
        </AnimatePresence>
      </div>
    </div>;
}